/* file description */

import type { UseSetVal } from './type';

export const useSetVal: UseSetVal = ({ onChange, form, field, config }) => {
  const { areaProvince, areaCity, areaCounty } = field?.bizConfig || {};
  const selectTree = (val: string | number) => {
    if (!val && config.from !== 'search') {
      form.setFieldValue(areaProvince, '');
      form.setFieldValue(areaCity, '');
      form.setFieldValue(areaCounty, '');
    }
    onChange?.(val);
  };
  return {
    selectTree,
  };
};
